import { useMemo } from "react";

export function useHasChanges(currentValues, originalValues) {
  const hasChanges = useMemo(() => {
    return JSON.stringify(currentValues) !== JSON.stringify(originalValues);
  }, [currentValues, originalValues]);

  return hasChanges;
}
